<section class="main-wrap inner-views dashboard-wrap" [ngClass]="{ 'menu-open in': !toggleClass }">

  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    <div class="content-container products-container single-product safety-shoe">
      <div class="row mb-0">
        <div class="col-md-12 dash-title">
          <h1>
            <a [routerLink]="['/products/safety-shoes']"><img height="10"
                src="assets/images/icons/angle-right-solid.svg" width="10" alt="Arrow Right Icon" />Back to Safety
              Shoes</a>
          </h1>
        </div>
        <div class="clearfix"></div>
        @if (shoe && shoeImages.length > 0) {
        <div class="col-md-7 product-img-wrap">
          <div class="carousel slide carousel-fade" data-interval="false" data-ride="carousel" id="product_1">
            <ol class="carousel-indicators indicator-thumbnails">
              @for (shoeImage of shoeImages; track $index; let i = $index) {
                <li [ngClass]="i == 0 ? 'active' : ''" [attr.data-slide-to]="i" [attr.data-target]="'#product_1'">
                  <img class="d-block w-100" [attr.src]="shoeImage" />
                </li>
              }
            </ol>
            <div class="carousel-inner">
              @for (shoeImage of shoeImages; track $index; let i = $index) {
                <div [ngClass]="i == 0 ? 'active' : ''" class="carousel-item">
                  <a [routerLink]="['/products/safety-shoes', shoe.style]">
                    <img class="d-block w-100" [attr.src]="shoeImage" />
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
        }
        <div class="col-md-7 product-description-wrap">
          <div class="single-product-desc">
            <div class="prod-desc">
              <h3 class="desc-title">Description</h3>
              @if (shoe?.description) {
                <div class="shoe-details" [innerHTML]="shoe?.description"></div>
              }
              @else {
                <p>No description provided by manufacturer.
                <p>
              }
              @if(!hasAttributes) {
                <h3 class="desc-title">Properties</h3>
                <div> {{ shoeProperties }} </div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-5 product-title-wrap">
          <div class="prod-col-in">
            <h2 class="prod-title">{{shoe?.brand}}</h2>
            <p class="prod-subtitle">{{shoe?.style}}</p>
            <p class="price">{{shoe?.price | currency}}</p>
            <app-product-attribute-icon-list
              [attributes]="shoe?.attributes">
            </app-product-attribute-icon-list>
            <p class="select-title text-uppercase font-weight-bold">Shoe Sizes:</p>
            <ul class="select-shoe">
              @for (size of shoeSizes; track $index; let i = $index) {
                <li>
                  <button autocomplete="off" [ngClass]="{ 'selected-size': i == selectedShoeSizeIndex }"
                    (click)="onSizeChange(size.value)" class="btn prod-size" data-toggle="button"
                    [disabled]="!size.isAvailable" type="button">{{size.value}}
                  </button>
                </li>
              }
            </ul>
            <p class="select-title text-uppercase font-weight-bold">Shoe Width:</p>
            <ul class="select-shoe">
              @for (width of shoeWidths; track $index; let i = $index) {
                <li>
                  <button autocomplete="off" [ngClass]="{ 'selected-width': i == selectedShoeWidthIndex}"
                    (click)="onWidthChange(width.value)" class="btn prod-width" data-toggle="button"
                    [disabled]="!width.isAvailable" type="button">{{width.value}}
                  </button>
                </li>
              }
            </ul>
            <p>
              <button (click)="addToCart()" class="btn product-btn gray-btn" type="button">Add to Cart</button>
            </p>
          </div>
        </div>
        <!--<div class="col-md-5 product-reviews-wrap">
          <div class="reviews">
            <h3>Reviews</h3>
            <div class="trustpilot" *ngIf="trustPilotDataSkus && currentSku">
              <app-product-reviews [currentSku]="currentSku" [trustPilotDataSkus]="trustPilotDataSkus"></app-product-reviews>
            </div>
          </div>
        </div> -->
      </div>
      @if (shoe?.attributes) {
        <div class="row mt-0 single-product" >
          <div class="col prod-desc">
            <app-product-attributes
              [attributes]="shoe?.attributes"
              [titleClass]="'descTitle'">
            </app-product-attributes>
          </div>
        </div>
      }
    </div>
  </div>
</section>
